// ============================================================================
// FNE-BRIDGE Frontend - Point d'entrée
// ============================================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/i18n';
import App from './App';
import './assets/styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
